import { useSelector } from "react-redux";

import BreadcrumbsMobile from "~/components/common/breadcrumbsMobile";
import ProductBody from "~/components/pages/productNew/body";
import { useProductViewTracking } from "~/hooks/useProductViewTracking";
import { SiteTypes } from "~/redux/reducers/paramsReducer";

import BaltexProductBody from "../../baltex/product/body";
import LandingsProductBody from "../../landings/product/body";
import styles from "./index.module.scss";

export default function ProductPage() {
  const { siteType } = useSelector((state: any) => state.params);

  useProductViewTracking();

  return (
    <div>
      <div className="container">
        <BreadcrumbsMobile />
      </div>
      <div className={styles.Product}>
        {siteType === SiteTypes.Baltex && <BaltexProductBody />}
        {siteType === SiteTypes.Farkop && <ProductBody />}
        {siteType === SiteTypes.Landing && <LandingsProductBody />}
      </div>
    </div>
  );
}
